import { render, staticRenderFns } from "./tourSwiper.vue?vue&type=template&id=6848aa58&scoped=true&"
import script from "./tourSwiper.vue?vue&type=script&lang=js&"
export * from "./tourSwiper.vue?vue&type=script&lang=js&"
import style0 from "./tourSwiper.vue?vue&type=style&index=0&id=6848aa58&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6848aa58",
  null
  
)

export default component.exports